import { render, staticRenderFns } from "./CGMP.vue?vue&type=template&id=2a4bad78&scoped=true"
import script from "./CGMP.vue?vue&type=script&lang=js"
export * from "./CGMP.vue?vue&type=script&lang=js"
import style0 from "./CGMP.vue?vue&type=style&index=0&id=2a4bad78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bad78",
  null
  
)

export default component.exports